import Vue from "vue"
import VueI18n from "vue-i18n"
import enLocale from "element-ui/lib/locale/lang/en"
import zhLocale from "element-ui/lib/locale/lang/zh-CN"
import * as api from "./api"
import apiPath from "./apiPath"
import * as base_url from "./base_url"
// -- import * as _ from "lodash-es"
import zh from "../../public/locales/zh-CN.json"
import en from "../../public/locales/en.json"

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh-CN", // 语言标识
  fallbackLocale: 'zh-CN',// 当语言不存在时；使用默认的语言
  messages: {
    "zh-CN": zhLocale,
    "en": enLocale
  }
})

// 异步加载语言包
const loadLanguageAsync = async function (locale, _i18n) {
  i18n.locale = locale
  let lang_data = {}
  // let _result_lang = await api.query_async({
  //   url: apiPath.language,
  //   parameters: { langname: locale },
  //   method: "get"
  // });

  // console.log(_result_lang)
  // if (_result_lang && _result_lang[0].result && _result_lang[0].result.data) {
  //   lang_data = _result_lang[0].result.data;
  // }
  switch (locale) {
    case "zh-CN": lang_data = zh; break
    case "en": lang_data = en; break
  }
  if (!_.isEmpty(lang_data)) {
    let lang_exists = i18n.getLocaleMessage(locale)
    i18n.setLocaleMessage(locale, Object.assign(lang_exists, lang_data))
  }
}

// 单独获取语言包
const getAloneLanguageAsync = function (locale, code) {
  i18n.locale = locale
  let lang_data = {}
  switch (locale) {
    case "zh-CN": lang_data = zh; break
    case "en": lang_data = en; break
  }
  return lang_data[code]
}

Vue.prototype.$loadLanguageAsync = loadLanguageAsync
Vue.prototype.$getAloneLanguageAsync = getAloneLanguageAsync

export default i18n
